export const buildInitialState = () => ({
  operations: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  clients: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  clientAssets: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  assets: {
      loading: false,
      lastUpdate: null,
      data: [],
      metadata: {},
  },
  // A Conta combina patrimônio atual, valores em trânsito e lançamentos
  // futuros (spec A1). O slice nasceu como lista, no padrão do gerador e igual
  // aos de cima, e assim ficou: a API da conta compõe o objeto na leitura, sem
  // exigir um formato diferente aqui.
  clientAccount: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  clientExtract: {
      loading: false,
      lastUpdate: null,
      data: [],
      metadata: {},
  },
  tranches: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  cashback: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  // Solicitações Backoffice (T010, esteira aawz_solicitacoes) — `data` é a
  // lista carregada via `apiWsSolicitacoes.carregar()`. `catalogo` (áreas +
  // tipos) segue o mesmo padrão de campo extra de `assets.metadata`/
  // `clientExtract.metadata`: não é o gerador que produz este campo, foi
  // adicionado à mão para o filtro "Serviço" e o formulário de nova
  // solicitação (T012) resolverem nome/instituições do tipo escolhido.
  solicitacoes: {
      loading: false,
      lastUpdate: null,
      data: [],
      catalogo: { areas: [], tipos: [] },
  },
  // {{NEXT}}
})

export default buildInitialState()
